import compose from 'localized-countries';

let countries = [];

export const loadLocalizedCountries = async ({ page: { languageCode } }) => {
  let dataSet;
  try {
    dataSet = await import(
      /* webpackChunkName: "localized-countries-[request]" */ `localized-countries/data/${languageCode}`
    );
  } catch (err) {
    dataSet = await import(
      /* webpackChunkName: "localized-countries-[request]" */ `localized-countries/data/en`
    );
  }
  countries = dataSet ? dataSet.default : countries;
};

export const localizedCountries = () =>
  compose(countries)
    .array()
    .map(({ code: value, label }) => ({ value, label }));

export const localeMappingList = {
  de_EE: 'de_DE',
  de_FI: 'de_DE',
  de_LV: 'de_DE',
  de_SK: 'de_DE',
  fr_BE: 'fr_FR',
  fr_LU: 'fr_FR',
  en_EU: 'en_BE',
  en_CZ: 'en_BE',
  en_EE: 'en_BE',
  en_FI: 'en_BE',
  en_FR: 'en_BE',
  en_GR: 'en_BE',
  en_HU: 'en_BE',
  en_LU: 'en_BE',
  en_LV: 'en_BE',
  en_PL: 'en_BE',
  en_PT: 'en_BE',
  en_SE: 'en_BE',
  en_SK: 'en_BE',
};

export const localeMapping = ({ locale = 'en_US', format = false }) => {
  const inputLocale = locale.replace('-', '_');
  const newLocale = Object.keys(localeMappingList).includes(inputLocale)
    ? localeMappingList[inputLocale]
    : inputLocale;
  return format ? newLocale.replace('_', '-') : newLocale;
};

export default localizedCountries;
